import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pnx-message',
    templateUrl: './message.control.html'
})
export class MessageControl implements OnInit {

    @Input() message: string;
    @Input() isError: boolean = false;
    @Input() showWarning: boolean = false;
    @Input() showMessage: boolean = false;
    @Input() messagecontainerstyle: string = 'col-md-12';

    @Output() cmdClose: EventEmitter<string> = new EventEmitter<string>();

    ngOnInit() {
    }
    
    // Close Message

    closeMessage() {
        this.showMessage = false;
        this.cmdClose.emit('Closed');
    }
}


// WEBPACK FOOTER //
// ./SignClient/app/shared/controls/message.control.ts